import * as Surplus from 'surplus'; // lgtm [js/unused-local-variable]
export function WarningsView({ projectPlan }) {
    return (<ul class="list-group">
        {warnings(projectPlan()).map((warning) => <li class="list-group-item">{warning.description}</li>)}
      </ul>);
}
function warnings(projectPlan) {
    return projectPlan === undefined
        ? []
        : projectPlan.warnings;
}
//# sourceMappingURL=warnings-view.jsx.map